/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';

interface CioConditionEditorUnknownArgs {
  condition: any;
  onRemove: () => unknown;
  disabled: boolean;
}

export default class CioConditionEditorUnknown extends Component<CioConditionEditorUnknownArgs> {
  @service auth!: AuthService;
}
